import { translate } from 'helpers/translateHelper';

export const VALID_TEXT_REGEX = /^[A-Za-z0-9 _]+$/;

export const hierarchyLocationModalTypes = {
    DELETE: 'DELETE',
    RENAME: 'RENAME',
    MOVE: 'MOVE'
};

export const NODE_TYPE = {
    ORGANIZATION: 'organization',
    SUB_ORGANIZATION: 'suborganization',
    SITE: 'site',
    LOCATION: 'location',
    POWERTRAIN: 'powertrain',
    ASSET: 'asset',
    UNASSIGNED_ASSETS: 'unassignedAssets',
    UNASSIGNED_POWERTRAINS: 'unassignedPowertrains',
    UNASSIGNED_POWERTRAIN: 'unassignedPowertrain',
};

export const NODE_MODIFICATION_TYPE = {
    ADD: 'add',
    RENAME: 'rename',
    DELETE: 'delete',
    MOVE: 'move',
    TEMP_INPUT: 'temp_input'
};
const hierarchyExternalNodeTypes = {
    UNASSIGNED_ASSETS: NODE_TYPE.UNASSIGNED_ASSETS,
    UNASSIGNED_POWERTRAINS: NODE_TYPE.UNASSIGNED_POWERTRAINS,
};

export const getTabOptions = () => {
    const options = [
        {
            label: translate('ABB.Powertrain.Frontend.powertrainsNotInHierarchy'),
            value: hierarchyExternalNodeTypes.UNASSIGNED_POWERTRAINS,
        },
        {
            label: translate('ABB.Powertrain.Frontend.singleAssetsLabel'),
            value: hierarchyExternalNodeTypes.UNASSIGNED_ASSETS,
        }
    ];

    return options;
};

export const PENDING_MOVE_TYPE = {
    DROP: 'drop',
    MOVE: 'move'
};
